export const CountryFile= [
    { "name": "United States", "code": "US", "emoji": "🇺🇸", "dial_code": "+1" },
    { "name": "Canada", "code": "CA", "emoji": "🇨🇦", "dial_code": "+1" },
    { "name": "Jamaica", "code": "JM", "emoji": "🇯🇲", "dial_code": "+1" },
    { "name": "Trinidad and Tobago", "code": "TT", "emoji": "🇹🇹", "dial_code": "+1" },
    { "name": "Barbados", "code": "BB", "emoji": "🇧🇧", "dial_code": "+1" },
    { "name": "Saint Lucia", "code": "LC", "emoji": "🇱🇨", "dial_code": "+1" },
    { "name": "Saint Vincent and the Grenadines", "code": "VC", "emoji": "🇻🇨", "dial_code": "+1" },
    { "name": "Grenada", "code": "GD", "emoji": "🇬🇩", "dial_code": "+1" },
    { "name": "Saint Kitts and Nevis", "code": "KN", "emoji": "🇰🇳", "dial_code": "+1" },
    { "name": "Antigua and Barbuda", "code": "AG", "emoji": "🇦🇬", "dial_code": "+1" },
    { "name": "Dominica", "code": "DM", "emoji": "🇩🇲", "dial_code": "+1" },

    { "name": "Montserrat", "code": "MS", "emoji": "🇲🇸", "dial_code": "+1" },
    { "name": "Bermuda", "code": "BM", "emoji": "🇧🇲", "dial_code": "+1" },
    { "name": "Cayman Islands", "code": "KY", "emoji": "🇰🇾", "dial_code": "+1" },
    { "name": "Turks and Caicos Islands", "code": "TC", "emoji": "🇹🇨", "dial_code": "+1" },
    { "name": "British Virgin Islands", "code": "VG", "emoji": "🇻🇬", "dial_code": "+1" },
    { "name": "Russia", "code": "RU", "emoji": "🇷🇺", "dial_code": "+7" },
    { "name": "Kazakhstan", "code": "KZ", "emoji": "🇰🇿", "dial_code": "+7" },
    { "name": "Egypt", "code": "EG", "emoji": "🇪🇬", "dial_code": "+20" },
    { "name": "South Africa", "code": "ZA", "emoji": "🇿🇦", "dial_code": "+27" },
    { "name": "Greece", "code": "GR", "emoji": "🇬🇷", "dial_code": "+30" },
    { "name": "Netherlands", "code": "NL", "emoji": "🇳🇱", "dial_code": "+31" },
    { "name": "Belgium", "code": "BE", "emoji": "🇧🇪", "dial_code": "+32" },
    { "name": "France", "code": "FR", "emoji": "🇫🇷", "dial_code": "+33" },
      { "name": "Spain", "code": "ES", "emoji": "🇪🇸", "dial_code": "+34" },
    { "name": "Italy", "code": "IT", "emoji": "🇮🇹", "dial_code": "+39" },
    { "name": "Romania", "code": "RO", "emoji": "🇷🇴", "dial_code": "+40" },
   

    { "name": "Switzerland", "code": "CH", "emoji": "🇨🇭", "dial_code": "+41" },
    { "name": "United Kingdom", "code": "GB", "emoji": "🇬🇧", "dial_code": "+44" },
    { "name": "Denmark", "code": "DK", "emoji": "🇩🇰", "dial_code": "+45" },
    { "name": "Sweden", "code": "SE", "emoji": "🇸🇪", "dial_code": "+46" },
    { "name": "Norway", "code": "NO", "emoji": "🇳🇴", "dial_code": "+47" },
    { "name": "Poland", "code": "PL", "emoji": "🇵🇱", "dial_code": "+48" },
    { "name": "Poland", "code": "PL", "emoji": "🇵🇱", "dial_code": "+48" },
    { "name": "Germany", "code": "DE", "emoji": "🇩🇪", "dial_code": "+49" },
    { "name": "Peru", "code": "PE", "emoji": "🇵🇪", "dial_code": "+51" },
    { "name": "Mexico", "code": "MX", "emoji": "🇲🇽", "dial_code": "+52" },
    { "name": "Argentina", "code": "AR", "emoji": "🇦🇷", "dial_code": "+54" },
    { "name": "Brazil", "code": "BR", "emoji": "🇧🇷", "dial_code": "+55" },
    { "name": "Chile", "code": "CL", "emoji": "🇨🇱", "dial_code": "+56" },
    { "name": "Chile", "code": "CL", "emoji": "🇨🇱", "dial_code": "+56" },
    { "name": "Colombia", "code": "CO", "emoji": "🇨🇴", "dial_code": "+57" },
    { "name": "Malaysia", "code": "MY", "emoji": "🇲🇾", "dial_code": "+60" },
    { "name": "Malaysia", "code": "MY", "emoji": "🇲🇾", "dial_code": "+60" },
    { "name": "Australia", "code": "AU", "emoji": "🇦🇺", "dial_code": "+61" },
    { "name": "Indonesia", "code": "ID", "emoji": "🇮🇩", "dial_code": "+62" },
    { "name": "Philippines", "code": "PH", "emoji": "🇵🇭", "dial_code": "+63" },
    { "name": "New Zealand", "code": "NZ", "emoji": "🇳🇿", "dial_code": "+64" },
    { "name": "Singapore", "code": "SG", "emoji": "🇸🇬", "dial_code": "+65" },
    { "name": "Thailand", "code": "TH", "emoji": "🇹🇭", "dial_code": "+66" },


    { "name": "Japan", "code": "JP", "emoji": "🇯🇵", "dial_code": "+81" },
    { "name": "South Korea", "code": "KR", "emoji": "🇰🇷", "dial_code": "+82" },
    { "name": "Vietnam", "code": "VN", "emoji": "🇻🇳", "dial_code": "+84" },
    { "name": "China", "code": "CN", "emoji": "🇨🇳", "dial_code": "+86" },
    { "name": "Turkey", "code": "TR", "emoji": "🇹🇷", "dial_code": "+90" },
    { "name": "India", "code": "IN", "emoji": "🇮🇳", "dial_code": "+91" },
    { "name": "Pakistan", "code": "PK", "emoji": "🇵🇰", "dial_code": "+92" },
    { "name": "Afghanistan", "code": "AF", "emoji": "🇦🇫", "dial_code": "+93" },
    { "name": "Sri Lanka", "code": "LK", "emoji": "🇱🇰", "dial_code": "+94" },
    { "name": "Myanmar", "code": "MM", "emoji": "🇲🇲", "dial_code": "+95" },
   
   
    { "name": "Western Sahara", "code": "EH", "emoji": "🇪🇭", "dial_code": "+212" },
  { "name": "Morocco", "code": "MA", "emoji": "🇲🇦", "dial_code": "+212" },
  { "name": "Algeria", "code": "DZ", "emoji": "🇩🇿", "dial_code": "+213" },
  { "name": "Tunisia", "code": "TN", "emoji": "🇹🇳", "dial_code": "+216" },
  { "name": "Libya", "code": "LY", "emoji": "🇱🇾", "dial_code": "+218" },
  
  { "name": "Gambia", "code": "GM", "emoji": "🇬🇳", "dial_code": "+220" },
  { "name": "Senegal", "code": "SN", "emoji": "🇸🇳", "dial_code": "+221" },
  { "name": "Mauritania", "code": "MR", "emoji": "🇲🇷", "dial_code": "+222" },
    { "name": "Mali", "code": "ML", "emoji": "🇲🇱", "dial_code": "+223" },
  { "name": "Guinea", "code": "GN", "emoji": "🇬🇳", "dial_code": "+224" },

  { "name": "Burkina Faso", "code": "BF", "emoji": "🇧🇫", "dial_code": "+226" },
  { "name": "Niger", "code": "NE", "emoji": "🇳🇪", "dial_code": "+227" },
  { "name": "Togo", "code": "TG", "emoji": "🇹🇬", "dial_code": "+228" },
  
   { "name": "Côte d'Ivoire", "code": "CI", "emoji": "🇮🇨", "dial_code": "+225" },

   { "name": "Benin", "code": "BJ", "emoji": "🇧🇯", "dial_code": "+229" },
   { "name": "Mauritius", "code": "MU", "emoji": "🇲🇺", "dial_code": "+230" },
  { "name": "Liberia", "code": "LR", "emoji": "🇱🇷", "dial_code": "+231" },
  { "name": "Sierra Leone", "code": "SL", "emoji": "🇸🇱", "dial_code": "+232" },
    
  { "name": "Ghana", "code": "GH", "emoji": "🇬🇭", "dial_code": "+233" },
  { "name": "Nigeria", "code": "NG", "emoji": "🇳🇬", "dial_code": "+234" },
  { "name": "Chad", "code": "TD", "emoji": "🇹🇩", "dial_code": "+235" },
    
  {
    "name": "Gabon", 
    "code": "GA",
    "emoji": "🇬🇦",
    "unicode": "U+1F1EC U+1F1E6",
    "image": "GA.svg",
    "dial_code": "+241"
},

  { "name": "Angola", "code": "AO", "emoji": "🇦🇴", "dial_code": "+244" },
    { "name": "Guinea-Bissau", "code": "GW", "emoji": "🇬🇼", "dial_code": "+245" },
    { "name": "Seychelles", "code": "SC", "emoji": "🇸🇨", "dial_code": "+248" },
  { "name": "Sudan", "code": "SD", "emoji": "🇸🇩", "dial_code": "+249" },


  





{
    "name": "Rwanda",
    "code": "RW", 
    "emoji": "🇷🇼",
    "unicode": "U+1F1F7 U+1F1FC",
    "image": "RW.svg",
    "dial_code": "+250"
},
{
    "name": "Ethiopia", 
    "code": "ET",
    "emoji": "🇪🇹",
    "unicode": "U+1F1EA U+1F1F9",
    "image": "ET.svg",
    "dial_code": "+251"
},




{ "name": "Somalia", "code": "SO", "emoji": "🇸🇴", "dial_code": "+252" },
  { "name": "Djibouti", "code": "DJ", "emoji": "🇩🇯", "dial_code": "+253" },




  {
    "name": "Kenya",
    "code": "KE",
    "emoji": "🇰🇪",
    "unicode": "U+1F1F0 U+1F1EA",
    "image": "KE.svg",
    "dial_code": "+254"
},
{
    "name": "Tanzania", 
    "code": "TZ",
    "emoji": "🇹🇿",
    "unicode": "U+1F1F9 U+1F1FF",
    "image": "TZ.svg",
    "dial_code": "+255"
},

{
    "name": "Uganda", 
    "code": "UG",
    "emoji": "🇺🇬",
    "unicode": "U+1F1FA U+1F1EC",
    "image": "UG.svg",
    "dial_code": "+256"
},


  { "name": "Mozambique", "code": "MZ", "emoji": "🇲🇿", "dial_code": "+258" },

  { "name": "Zambia", "code": "ZM", "emoji": "🇿🇲", "dial_code": "+260" },
  { "name": "Madagascar", "code": "MG", "emoji": "🇲🇬", "dial_code": "+261" },
  { "name": "Réunion", "code": "RE", "emoji": "🇷🇪", "dial_code": "+262" },
  { "name": "Zimbabwe", "code": "ZW", "emoji": "🇿🇼", "dial_code": "+263" },
  { "name": "Namibia", "code": "NA", "emoji": "🇳🇦", "dial_code": "+264" },
  { "name": "Malawi", "code": "MW", "emoji": "🇲🇼", "dial_code": "+265" },
  { "name": "Lesotho", "code": "LS", "emoji": "🇱🇸", "dial_code": "+266" },
  { "name": "Botswana", "code": "BW", "emoji": "🇧🇼", "dial_code": "+267" },
  { "name": "Eswatini", "code": "SZ", "emoji": "🇸🇿", "dial_code": "+268" },

    
  {
    "name": "Swaziland (Eswatini)", 
    "code": "SZ",
    "emoji": "🇸🇿",
    "unicode": "U+1F1F8 U+1F1FF",
    "image": "SZ.svg",
    "dial_code": "+268"
},
  { "name": "Comoros", "code": "KM", "emoji": "🇰🇲", "dial_code": "+269" },
  { "name": "Mayotte", "code": "YT", "emoji": "🇾🇹", "dial_code": "+269" },


  { "name": "Saint Helena", "code": "SH", "emoji": "🇸🇭", "dial_code": "+290" },

  
    { "name": "Eritrea", "code": "ER", "emoji": "🇪🇷", "dial_code": "+291" },

  
   
 
    { "name": "Portugal", "code": "PT", "emoji": "🇵🇹", "dial_code": "+351" },

    { "name": "Ireland", "code": "IE", "emoji": "🇮🇪", "dial_code": "+353" },
    
    { "name": "Finland", "code": "FI", "emoji": "🇫🇮", "dial_code": "+358" },

    { "name": "Moldova", "code": "MD", "emoji": "🇲🇩", "dial_code": "+373" },
    { "name": "Armenia", "code": "AM", "emoji": "🇦🇲", "dial_code": "+374" },
    { "name": "Ukraine", "code": "UA", "emoji": "🇺🇦", "dial_code": "+380" },


    
 
  { "name": "Czech Republic", "code": "CZ", "emoji": "🇨🇿", "dial_code": "+420" },
  
 
  { "name": "Saudi Arabia", "code": "SA", "emoji": "🇸🇦", "dial_code": "+966" },
  { "name": "Israel", "code": "IL", "emoji": "🇮🇱", "dial_code": "+972" },

 
 
  
  { "name": "Bangladesh", "code": "BD", "emoji": "🇧🇩", "dial_code": "+880" },


  




  { "name": "Lebanon", "code": "LB", "emoji": "🇱🇧", "dial_code": "+961" },
  { "name": "Jordan", "code": "JO", "emoji": "🇯🇴", "dial_code": "+962" },


  { "name": "Iraq", "code": "IQ", "emoji": "🇮🇶", "dial_code": "+964" },
  { "name": "Kuwait", "code": "KW", "emoji": "🇰🇼", "dial_code": "+965" },

  { "name": "Oman", "code": "OM", "emoji": "🇴🇲", "dial_code": "+968" },

  { "name": "Bahrain", "code": "BH", "emoji": "🇧🇭", "dial_code": "+973" },


  
  { "name": "Belize", "code": "BZ", "emoji": "🇧🇿", "dial_code": "+501" },
  { "name": "Guatemala", "code": "GT", "emoji": "🇬🇹", "dial_code": "+502" },
  { "name": "El Salvador", "code": "SV", "emoji": "🇸🇻", "dial_code": "+503" },
  { "name": "Honduras", "code": "HN", "emoji": "🇭🇳", "dial_code": "+504" },
  { "name": "Nicaragua", "code": "NI", "emoji": "🇳🇮", "dial_code": "+505" },
  { "name": "Costa Rica", "code": "CR", "emoji": "🇨🇷", "dial_code": "+506" },
  { "name": "Panama", "code": "PA", "emoji": "🇵🇦", "dial_code": "+507" },
  
  { "name": "Saint Pierre and Miquelon", "code": "PM", "emoji": "🇵🇲", "dial_code": "+508" },
  { "name": "Bolivia", "code": "BO", "emoji": "🇧🇴", "dial_code": "+591" },
  
     { "name": "Ecuador", "code": "EC", "emoji": "🇪🇨", "dial_code": "+593" },
    { "name": "Paraguay", "code": "PY", "emoji": "🇵🇾", "dial_code": "+595" },
    { "name": "Uruguay", "code": "UY", "emoji": "🇺🇾", "dial_code": "+598" },
    



    { "name": "Saint Martin", "code": "MF", "emoji": "🇲🇫", "dial_code": "+590" },
  { "name": "Guadeloupe", "code": "GP", "emoji": "🇬🇵", "dial_code": "+590" },
  { "name": "Saint Barthélemy", "code": "BL", "emoji": "🇧🇱", "dial_code": "+590" },
  { "name": "Saint Martin", "code": "MF", "emoji": "🇲🇫", "dial_code": "+590" },
  { "name": "French Guiana", "code": "GF", "emoji": "🇬🇫", "dial_code": "+594" },

  { "name": "Martinique", "code": "MQ", "emoji": "🇲🇶", "dial_code": "+596" },



  { "name": "Wallis and Futuna", "code": "WF", "emoji": "🇼🇫", "dial_code": "+681" },
  { "name": "Cook Islands", "code": "CK", "emoji": "🇨🇰", "dial_code": "+682" },
  
  { "name": "New Caledonia", "code": "NC", "emoji": "🇳🇨", "dial_code": "+687" },
    { "name": "French Polynesia", "code": "PF", "emoji": "🇵🇫", "dial_code": "+689" },



  { "name": "Cambodia", "code": "KH", "emoji": "🇰🇭", "dial_code": "+855" },
  { "name": "Laos", "code": "LA", "emoji": "🇱🇦", "dial_code": "+856" },
  { "name": "Bangladesh", "code": "BD", "emoji": "🇧🇩", "dial_code": "+880" },


  { "name": "Maldives", "code": "MV", "emoji": "🇲🇻", "dial_code": "+960" },
  { "name": "Lebanon", "code": "LB", "emoji": "🇱🇧", "dial_code": "+961" },
  { "name": "Jordan", "code": "JO", "emoji": "🇯🇴", "dial_code": "+962" },
  { "name": "Syria", "code": "SY", "emoji": "🇸🇾", "dial_code": "+963" },
  { "name": "Iraq", "code": "IQ", "emoji": "🇮🇶", "dial_code": "+964" },
  { "name": "Kuwait", "code": "KW", "emoji": "🇰🇼", "dial_code": "+965" },

  { "name": "Saudi Arabia", "code": "SA", "emoji": "🇸🇦", "dial_code": "+966" },
 
  { "name": "Yemen", "code": "YE", "emoji": "🇾🇪", "dial_code": "+967" },
  { "name": "Oman", "code": "OM", "emoji": "🇴🇲", "dial_code": "+968" },
  { "name": "Palestine", "code": "PS", "emoji": "🇵🇸", "dial_code": "+970" },
  { "name": "United Arab Emirates", "code": "AE", "emoji": "🇦🇪", "dial_code": "+971" },
   
  { "name": "Israel", "code": "IL", "emoji": "🇮🇱", "dial_code": "+972" },
 
  { "name": "Bahrain", "code": "BH", "emoji": "🇧🇭", "dial_code": "+973" },
  { "name": "Qatar", "code": "QA", "emoji": "🇶🇦", "dial_code": "+974" },
  { "name": "Bhutan", "code": "BT", "emoji": "🇧🇹", "dial_code": "+975" },
  { "name": "Mongolia", "code": "MN", "emoji": "🇲🇳", "dial_code": "+976" },
  { "name": "Nepal", "code": "NP", "emoji": "🇳🇵", "dial_code": "+977" },


    { "name": "Tajikistan", "code": "TJ", "emoji": "🇹🇯", "dial_code": "+992" },
  { "name": "Turkmenistan", "code": "TM", "emoji": "🇹🇲", "dial_code": "+993" },


 
  
    { "name": "Azerbaijan", "code": "AZ", "emoji": "🇦🇿", "dial_code": "+994" },
    { "name": "Georgia", "code": "GE", "emoji": "🇬🇪", "dial_code": "+995" },
  
    { "name": "Kyrgyzstan", "code": "KG", "emoji": "🇰🇬", "dial_code": "+996" },

 
  { "name": "Uzbekistan", "code": "UZ", "emoji": "🇺🇿", "dial_code": "+998" }
 










]